/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { CommentableContentField } from "./CommentableContentField";

export interface CommentableContentContent {
  title: string;
  fields?: CommentableContentField[];
  body: string[];
}
